import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';

import { Observable, throwError } from 'rxjs';
import { Keyword, ScSelection } from '../_models';
import { BaseResponse, ListResponse, ArrayResponse } from '../_common';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class KeywordService {

    constructor(private http: HttpClient) { }

    getKeyword(id: any): Observable<Keyword> { //detail
      return this.http.get(`${environment.apiUrl}/keyword/find/${id}`)
      .pipe(
        map((data: BaseResponse) => {
          return new Keyword().deserialize(data.data);
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    getAll(filter: any): Observable<ListResponse>  { //listing
      return this.http.post(`${environment.apiUrl}/keyword/list`, JSON.stringify(filter))
      .pipe(
        map((data: ListResponse) => {
          if(data.status == 1 && data.data.list == undefined){
            return null;
          }else{
            return new ListResponse().deserialize(data, Keyword);
          }
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    export(filter: any): Observable<any> { //export
      return this.http.post(`${environment.apiUrl}/keyword/export`, filter);
    }

    exportAllKeywords(): Observable<any> { //export
      return this.http.get(`${environment.apiUrl}/keyword/export-all-keywords`);
    }

    exportAllAffiliates(): Observable<any> { //export
      return this.http.get(`${environment.apiUrl}/keyword/export-all-affiliates`);
    }

    uploadKeywords(formData): Observable<any> {
      return this.http.post(`${environment.apiUrl}/keyword/upload`, formData)
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    uploadAffiliate(formData): Observable<any> {
      return this.http.post(`${environment.apiUrl}/keyword/affiliate/upload`, formData)
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    addKeyword(data): Observable<BaseResponse> {
      return this.http.post(`${environment.apiUrl}/keyword/save`, JSON.stringify(data))
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    updateKeyword(data): Observable<BaseResponse> {
      return this.http.post(`${environment.apiUrl}/keyword/update/${data.id}`, JSON.stringify(data))
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    deleteKeyword(id: any): Observable<BaseResponse> {
      return this.http.delete(`${environment.apiUrl}/keyword/delete/${id}`)
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    getSelectionSources(flag = ""): Observable<any> {
      return this.http.get(`${environment.apiUrl}/keyword/selection/source?flag=${flag}`)
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    getSelectionSourcesAndSc(country, operator): Observable<any> {
      return this.http.get(`${environment.apiUrl}/keyword/selection/source-sc?country=${country}&operator=${operator}`)
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    getSelectionShortCodes(sourceId, countryCode, flag = ""): Observable<any>{
      return this.http.get(`${environment.apiUrl}/keyword/selection/sc?source=${sourceId}&country=${countryCode}&flag=${flag}`).pipe(
        map((data:any)=>{
          return data;
        }),
        catchError(error => throwError(error.message ||error))
      );
    }

    getSelectionShortCodesForClient(): Observable<any>{
      return this.http.get(`${environment.apiUrl}/keyword/selection/client/sc`).pipe(
        map((data:any)=>{
          return data;
        }),
        catchError(error => throwError(error.message ||error))
      );
    }

    getSelectionKws(operator, shortCode): Observable<any>{
      return this.http.get(`${environment.apiUrl}/keyword/selection/kws?operator=${operator}&shortCode=${shortCode}`).pipe(
        map((data:any)=>{
          return data;
        }),
        catchError(error => throwError(error.message ||error))
      );
    }

    getSelectionKwsForClient(operator, shortCode): Observable<any>{
      return this.http.get(`${environment.apiUrl}/keyword/selection/client/kws?operator=${operator}&shortCode=${shortCode}`).pipe(
        map((data:any)=>{
          return data;
        }),
        catchError(error => throwError(error.message ||error))
      );
    }

    getSelectionScKws(sourceId, countryCode): Observable<any>{
      return this.http.get(`${environment.apiUrl}/keyword/selection/sc-kws?source=${sourceId}&country=${countryCode}`).pipe(
        map((data:any)=>{
          return data;
        }),
        catchError(error => throwError(error.message ||error))
      );
    }

    getSelectionScKwsLight(sourceId, countryCode, flag = ""): Observable<any>{
      return this.http.get(`${environment.apiUrl}/keyword/selection/sc-kws-light?source=${sourceId}&country=${countryCode}&flag=${flag}`).pipe(
        map((data:any)=>{
          return data;
        }),
        catchError(error => throwError(error.message ||error))
      );
    }

    getGrant(userId): Observable<any>{
      return this.http.get(`${environment.apiUrl}/keyword/grant/${userId}/selection`)
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    addGrant(clientId, params): Observable<any>{
      return this.http.post(`${environment.apiUrl}/keyword/grant/${clientId}/submit`, params)
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    allShortCodeForSelection(): Observable<ArrayResponse>{
      return this.http.get(`${environment.apiUrl}/keyword/selection/sc-all`)
      .pipe(
        map((data: any) => {
          if(data && data.status && data.status == 1 && data.data){
             return new ArrayResponse().deserialize(data, ScSelection);
          }else{
             return null;
          }
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    allShortCodeWithoutOperatorForSelection(): Observable<ArrayResponse>{
      return this.http.get(`${environment.apiUrl}/keyword/selection/sc-all-without-operator`)
      .pipe(
        map((data: any) => {
          if(data && data.status && data.status == 1 && data.data){
             return new ArrayResponse().deserialize(data, ScSelection);
          }else{
             return null;
          }
        }),
        catchError(error => throwError(error.message || error))
      );
    }

}
